// extracted by mini-css-extract-plugin
module.exports = {"Layout1":"Layout1___1p3hS","Header1":"Header1___2fHg1","Content1":"Content1___CLNOA"};